/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDRadiusUpLeftIcon24Regular = forwardRef('ArrowDRadiusUpLeftIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M8.502 2.781A.875.875 0 0 1 9.739 4.02L4.633 9.125H12c5.454 0 9.875 4.421 9.875 9.875v1a.875.875 0 1 1-1.75 0v-1A8.125 8.125 0 0 0 12 10.875H4.633l5.106 5.106a.875.875 0 0 1-1.237 1.238L3.175 11.89a2.675 2.675 0 0 1 0-3.783l5.327-5.327Z" })));
});
